import { useEffect, useState } from "react";

const isMobileInitialValue =
  /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    navigator.userAgent,
  );

const portraitDetectInitialValue =
  window?.screen?.orientation?.type?.includes("portrait") || false;

export const useDeviceStateDetection = () => {
  const [isMobile, _setIsMobile] = useState(isMobileInitialValue);
  const [portrait, setPortrait] = useState(portraitDetectInitialValue);

  useEffect(() => {
    const changeOrientation = () => {
      if (window?.screen?.orientation?.type?.includes("portrait")) {
        setPortrait(true);
      } else {
        setPortrait(false);
      }
    };

    window?.screen?.orientation?.addEventListener("change", changeOrientation);

    return () => {
      window?.screen?.orientation?.removeEventListener(
        "change",
        changeOrientation,
      );
    };
  }, []);

  return { isMobile, portrait };
};
